(() => {
  const dialog = document.getElementById('MaeCustomization');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const panel = dialog.querySelector('.mae-customization__panel');
  const scrim = dialog.querySelector('.mae-customization__scrim');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const motionStyle = getComputedStyle(document.documentElement);
  const openResponse = Number(motionStyle.getPropertyValue('--mae-dialog-open-response')) || 16;
  const closeResponse = Number(motionStyle.getPropertyValue('--mae-dialog-close-response')) || 12;
  let previousFocus;
  let position = 0;
  let velocity = 0;
  let target = 0;
  let frame = 0;
  let lastTime = 0;
  let state = 'closed';
  let distance = 1;
  const measure = () => { distance = Math.max(32, dialog.clientHeight - panel.offsetTop + 24); };
  const render = () => {
    const visible = Math.max(0, Math.min(1, 1 - position / distance));
    panel.style.transform = reducedMotion.matches ? 'none' : `translate3d(0, ${position}px, 0)`;
    panel.style.opacity = reducedMotion.matches ? String(visible) : '1';
    scrim.style.opacity = String(visible);
  };
  const tick = (time) => {
    const elapsed = Math.min((time - lastTime) / 1000 || 1 / 60, 1 / 30);
    lastTime = time;
    const response = reducedMotion.matches ? 27 : state === 'closing' ? closeResponse : openResponse;
    let remaining = elapsed;
    while (remaining > 0) {
      const step = Math.min(remaining, 1 / 240);
      velocity += (-response * response * (position - target) - 2 * response * velocity) * step;
      position += velocity * step;
      remaining -= step;
    }
    render();
    if (Math.abs(position - target) < .3 && Math.abs(velocity) < 2) {
      position = target;
      velocity = 0;
      frame = 0;
      render();
      state = target === 0 ? 'open' : 'closed';
      dialog.dataset.motionState = state;
      panel.style.willChange = 'auto';
      scrim.style.willChange = 'auto';
      if (state === 'closed') dialog.close();
      return;
    }
    frame = requestAnimationFrame(tick);
  };
  const move = (nextTarget, nextState) => {
    target = nextTarget;
    state = nextState;
    dialog.dataset.motionState = state;
    panel.style.willChange = reducedMotion.matches ? 'opacity' : 'transform';
    scrim.style.willChange = 'opacity';
    if (!frame) {
      lastTime = performance.now();
      frame = requestAnimationFrame(tick);
    }
  };
  const show = (trigger) => {
    if (dialog.open && state !== 'closing') return;
    if (!dialog.open) {
      previousFocus = trigger.closest('#MobileMenu') ? document.querySelector('.menu-toggle') : trigger;
      dialog.showModal();
      document.documentElement.classList.add('mae-customization-open');
      measure();
      position = distance;
      velocity = 0;
      render();
      dialog.querySelector('h2').focus({ preventScroll: true });
    }
    move(0, 'opening');
  };
  const close = () => {
    if (!dialog.open || state === 'closed' || state === 'closing') return;
    measure();
    move(distance, 'closing');
  };
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-customization-open]');
    if (trigger) show(trigger);
  });
  dialog.querySelector('[data-customization-close]').addEventListener('click', close);
  dialog.addEventListener('click', (event) => { if (event.target === dialog || event.target === scrim) close(); });
  dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
  dialog.addEventListener('close', () => {
    cancelAnimationFrame(frame);
    frame = 0;
    state = 'closed';
    dialog.dataset.motionState = state;
    panel.style.willChange = 'auto';
    scrim.style.willChange = 'auto';
    document.documentElement.classList.remove('mae-customization-open');
    if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
  });
  const resize = () => {
    if (!dialog.open) return;
    measure();
    if (state === 'closing') target = distance;
    render();
  };
  new ResizeObserver(resize).observe(panel);
  window.addEventListener('resize', resize, { passive: true });
  window.visualViewport?.addEventListener('resize', resize, { passive: true });
  reducedMotion.addEventListener('change', render);
})();
